import axios, { AxiosHeaders, AxiosResponse, ResponseType } from "axios";

import store from "@/store/index";
import { HttpRequest, HttpResponse, IHttpClient } from "./request.types";

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      store.dispatch("auth/logout");
    }
    return Promise.reject(error);
  },
);

class HttpClient implements IHttpClient {
  public request<T>(data: HttpRequest): Promise<HttpResponse<T>> {
    return axios
      .request({
        url: data.url,
        method: data.method,
        data: data.body,
        headers: data.headers as AxiosHeaders,
        responseType: data.responseType as ResponseType,
      })
      .then((res: AxiosResponse<T>) => {
        return {
          body: res.data,
        };
      })
      .catch(error => {
        console.log(error);
        throw error;
      });
  }
}

export default new HttpClient();
